import { GraphQLClient } from "graphql-request";
import { MYBESTUSER_API } from "../config/environment";
import store from "../store/configureStore";
import { setNotify } from "../actions/notifyActions";
import { isAuthError } from "./isAuthError";

export { isAuthError };

let graphQLClient = null;

const authorizationHeader = () => {
  const token = localStorage.getItem("token");
  return token ? `Bearer ${token}` : "";
};

const create = () => {
  const client = new GraphQLClient(MYBESTUSER_API + "/graphql", {
    headers: {
      authorization: authorizationHeader()
    }
  });

  // Wrap request method to catch auth errors
  const originalRequest = client.request.bind(client);
  client.request = async (...args) => {
    // The client is a singleton, but the token is not: a sign-in on the
    // /mybestuser route replaces it without a page load, and the tablet
    // SSO flow signs in on a page that may already have created the client
    // with the previous, since-revoked token. Read it on every request.
    client.setHeader("authorization", authorizationHeader());
    try {
      return await originalRequest(...args);
    } catch (error) {
      if (isAuthError(error)) {
        console.warn(
          "[GraphQL Client] Auth error - Token invalid or user logged out"
        );

        // Clear token from localStorage
        localStorage.removeItem("token");

        // Dispatch notify action to show modal
        store.dispatch(
          setNotify(
            "Your session has expired or you have been logged out. Please login again.",
            null, // confirm callback
            null, // cancel callback
            true // forceRelogin = true
          )
        );
      }

      throw error;
    }
  };

  return client;
};

// A background lookup the page can do without (e.g. a name for a label):
// a refusal is only thrown to the caller. It must not go through the client
// above, whose auth check would sign the user out over an answer such as
// "Unauthorized" to a query this account may not run.
export const requestInBackground = (query, variables) => {
  const token = localStorage.getItem("token");
  return new GraphQLClient(MYBESTUSER_API + "/graphql", {
    headers: { authorization: token ? `Bearer ${token}` : null }
  }).request(query, variables);
};

export const initGQLClient = () => {
  if (!graphQLClient) {
    graphQLClient = create();
  }

  return graphQLClient;
};
